import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { isLoggedIn } from "../../util";

import "react-notifications/lib/notifications.css";
import {
    NotificationContainer,
    NotificationManager,
} from "react-notifications";
import DTCLocation from "./Locations.jsx";
import TableView from "../commonViews/TableView.jsx";
import ModalView from "../commonViews/ModalView.jsx";
import {
    getTextColor,
    getMainBackground,
    getMatchingTint,
    getFontColor,
} from "../../ThemeHandlers/theme";

import { fetchDTCTemplatesAction } from '../../actions/dtc_actions';

class Templates extends React.Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            dtcSelectedTemplate: {},
            selectedTemplateData: "",
            thisTemplatesView: true,
            thisReportDownloading: false,
            template: {},
            templates: [],
            matTableLoad: false,
            color: "",
            templateId: ''
        };
    }

    componentDidMount() {
        if (!isLoggedIn(this.props.auth)) {
            this.props.history.push(`/login`);
            return;
        }
        if (this.props.auth.color) {
            this.setState({ color: this.props.auth.color });
        }
        this.setState({ matTableLoad: true });
        this.props.fetchDTCTemplatesAction({
            onSuccess: (res) => {
                this.setState({ matTableLoad: false, templates: res.templates });
            },
            onFailure: () => {
                this.setState({ matTableLoad: false });
            },
        });


    }
    componentDidUpdate(prevProps) {
        if (this.props.auth.color !== prevProps.auth.color) {
            this.setState({ color: this.props.auth.color });
        }

    }

    handleCloseClick = () => {
        this.setState({ thisTemplatesView: true });
    };

    handleTableViewAuditClick = (template) => {
        this.setState({
            dtcSelectedTemplate: template,
            thisTemplatesView: false,
        });
    };

    sendedData = (rowData, row) => {
        console.log(rowData, 'row')

    };

    render() {
        var templates =
            this.state.templates.length !== 0 ? this.state.templates : [];


        var col = [
            {
                title: "Template Name",
                field: "auditName",
                render: (rowData) => {
                    return (
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                this.handleTableViewAuditClick(rowData);
                            }}
                        >
                            {rowData.auditName}
                        </span>
                    );
                },
            },

        ];

        return (
            <div style={{ flexGrow: 1, display: "flex", flexFlow: "column" }}>
                <NotificationContainer />
                {this.state.thisTemplatesView && (
                    <div>
                        <h1 style={{ color: getTextColor(this.state.color) }}>Templates</h1>

                        <TableView
                            columns={col}
                            data={templates}
                            selection={false}
                            load={this.state.matTableLoad}
                        />
                    </div>
                )}
                {!this.state.thisTemplatesView && (
                    <DTCLocation
                        selectedTemplate={this.state.dtcSelectedTemplate}
                        onClose={this.handleCloseClick}
                        color={this.state.color}
                    />
                )}

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchDTCTemplatesAction
        },
        dispatch
    );
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Templates)
);
